export var SENT_AND_RECEIVED = "";
export var SENT = "sent";
export var RECEIVED = "received";
export var SENT_RECEIVED_SORT_OPTIONS = [
    { value: SENT_AND_RECEIVED, label: "recognition.account.recognition.sortBy.options.sentAndReceived" },
    { value: SENT, label: "recognition.account.recognition.sortBy.options.sent" },
    { value: RECEIVED, label: "recognition.account.recognition.sortBy.options.received" }
];
export default {
    SENT_AND_RECEIVED: SENT_AND_RECEIVED,
    SENT: SENT,
    RECEIVED: RECEIVED,
    OPTIONS: SENT_RECEIVED_SORT_OPTIONS
};
